<template>
    <div>
        <div class="container d-flex flex-column gap-4">
            <div class="row g-4">
                <div class="col-lg-4 col-md-6 col-sm-6" v-for="item in data.slice(0, 6)" :key="item.id">
                    <div class="card">
                        <div class="card-img-container">
                            <div class="card-img-bg" :style="`background-image: url('${item.imageUrl.split(',')[0]}')`">
                            </div>

                          
                            <img :src="`${item.imageUrl.split(',')[0]}`" class="card-img-foreground" alt="Post image" />
                        </div>
                        <div class="card-body">
                            <p class="date_post">{{ item.data_postimit }}</p>
                            <h5 class="card-title" @click="redirectToPst(item.id)" :title="item.titulli">{{ item.titulli
                            }}</h5>
                            <div class="mt-auto text-start boxchips">
                                <prokuroria-chips :item="item.prokuroria" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ProkuroriaChips from './ProkuroriaChips.vue';


export default {
    components: { ProkuroriaChips },
    props: ['data'],
    computed: {
          chunkedData() {
            const width = this.screenWidth;
            let chunkSize = 3;
            if (width < 580) {
            chunkSize = 1;
            } else if (width < 992) {
            chunkSize = 2;
            } else {
            chunkSize = 3;
            }
            const limitedData = this.data.slice(0, 6); // Nëse do të kufizosh në 6 item
            return limitedData.reduce((acc, item, index) => {
            const chunkIndex = Math.floor(index / chunkSize);
            if (!acc[chunkIndex]) acc[chunkIndex] = [];
            acc[chunkIndex].push(item);
            return acc;
            }, []);
        }
    },
    methods: {
        redirectToPst(postId){
            this.$router.push(`/artikulli/${postId}`);
        }

    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>
<style scoped>
.card-body {
    background-color: #FFFFFF;
    border-bottom-left-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
    padding: 16px;
}

.card {
    margin: 0 !important;
    border: transparent !important;
    height: 434px !important;
    border-radius: 6px !important;
    position: relative;
}

.card img {
    height: 243px !important;
    object-fit: contain;
}

.date_post {
    font-size: 13px;
    color: #475467;
    font-weight: 400;
    letter-spacing: -1%;
}

.card-title {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    /* Kufizon titullin deri në 3 rreshta */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    line-height: 1.5;
    max-height: calc(1.5em * 4);
    font-size: 16px;
    font-weight: 500;
    color: #101828;
    margin-top: 10px;

}

.boxchips {
    position: absolute;
    bottom: 15px;
}

.card-img-container {
    position: relative;
    width: 100%;
    height: 243px;
    overflow: hidden;
    border-radius: 12px 12px 0 0;
    border-top-left-radius: 6px !important;
    border-top-right-radius: 6px !important;
}

.card-img-bg {
    background-image: url('../../assets/test.jpg');
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: blur(6px);
    /* Opsionale për efekt estetik */
}

.card-img-foreground {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;
    z-index: 1;
}
h5{
    cursor:pointer !important;
}
</style>